import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      basket: state => state.baskets.basket,
      newOrder: state => state.newOrder,
      fastOrder: state => state.fastOrder,
    }),
    isNewOrderPage () {
      return this.$route.name === 'newOrder'
    },
    isFastOrderEditPage () {
      return this.$route.name === 'fastOrderEdit'
    },
    orderState () {
      return this.isNewOrderPage ? this.newOrder : this.fastOrder
    },
    orderEditPrefix () {
      return this.isNewOrderPage ? 'newOrder' : 'fastOrder'
    },
    basketFilialId () {
      return this.basket?.filial?.id
    },
  },
}
